import { Heart, Loader2 } from 'lucide-react';
import { StaticMetricCardAlt } from '@/components/StaticMetricCardAlt';
import { useAssetHealthOverview } from '@/hooks/use-asset-management-widgets';
import { Card, CardContent } from '@/components/ui/card';

interface KpiAssetHealthProps {
  readonly className?: string;
}

export function KpiAssetHealth({ className }: KpiAssetHealthProps): React.ReactElement {
  const { data, isLoading } = useAssetHealthOverview();

  const totalAssets = data?.totalAssets ?? 0;
  const alertCount = data?.alertCount ?? 0;
  const healthPercentage = totalAssets > 0 ? (((totalAssets - alertCount) / totalAssets) * 100).toFixed(0) : '100';

  if (isLoading) {
    return (
      <Card className="overflow-hidden border-0">
        <CardContent className="p-6 h-[148px] flex flex-col items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <span className="text-sm text-muted-foreground mt-2">Loading...</span>
        </CardContent>
      </Card>
    );
  }

  return (
    <StaticMetricCardAlt
      title="Asset Health"
      value={`${healthPercentage}%`}
      change={alertCount > 0 ? `${alertCount}` : '0'}
      changeLabel={alertCount > 0 ? 'alerts' : 'all healthy'}
      icon={Heart}
      variant="info"
    />
  );
}
